import { LoadingState } from '@vrzl/ui';

// Why: MSAL's loginPopup reads the `#code=...` fragment from this window's
// URL to finish the SSO flow. Any client-side navigation here (useNavigate,
// <Navigate>, history.replaceState, useAuth-driven redirects) strips the
// hash and triggers `hash_empty_error`. Keep this component navigation-free.
export function AuthRedirectPage() {
  return <LoadingState message="Bezig met inloggen..." className="min-h-screen" />;
}
